export function trimHTML(html: string) {
  // Remove <p><br></p> or <p></p> at start/end, and trim whitespace. Note this does not remove headings or formatting elements. We may use custom nodes that don't have textContent so when changing this function we need to be mindful about not trimming those.
  return html
    .replace(/^(<p>(?:\s*|(?:\s*<br\s*\/?>\s*)+)<\/p>)+/g, '') // leading empties
    .replace(/(<p>(?:\s*|(?:\s*<br\s*\/?>\s*)+)<\/p>)+$/g, '') // trailing empties
    .trim()
}
